"use strict";

var _slicedToArray = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var config_1 = require("@navent-jobs/config");

var facets_1 = require("./facets");

var i18n_1 = __importDefault(require("./../i18n"));

var filters_1 = require("./filters");

var FichaAvisoUrlInitialState = {
  id: undefined,
  titulo: '',
  empresa: {
    denominacion: '',
    confidencial: false
  }
};

exports.makeCompanyURL = function (empresa) {
  return empresa.confidencial ? '' : "/perfiles/empresa_".concat(config_1.formatNameToStringId(empresa.denominacion), "_").concat(empresa.id, ".html");
};

exports.makeFichaAvisoURL = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FichaAvisoUrlInitialState,
      id = _ref.id,
      titulo = _ref.titulo,
      empresa = _ref.empresa;

  var FICHA_AVISO_PREFIX = '/empleos/';
  var FICHA_AVISO_SUFFIX = '.html';
  return "".concat(FICHA_AVISO_PREFIX).concat(config_1.formatNameToStringId(titulo)).concat(empresa.confidencial ? "" : "-".concat(config_1.formatNameToStringId(empresa.denominacion)), "-").concat(id).concat(FICHA_AVISO_SUFFIX);
};

exports.parseURL = function (urlToParseParam, match) {
  var _a;

  var filtros = {
    area: [],
    subarea: [],
    apto_discapacitado: [],
    dias_fecha_publicacion: [],
    distancia: [],
    nivel_laboral: [],
    modalidad_trabajo: []
  };

  if (match) {
    if (match.params.provincia) {
      filtros.provincia = [match.params.provincia];

      if (match.params.localidad) {
        filtros.localidad = [match.params.localidad];
      }
    }
  }

  var url = urlToParseParam.replace(i18n_1.default.t('url.salario.salario-sin-especificar'), '$*-$*');
  var urlToParse = url.split('.html')[0];

  var _urlToParse$split = urlToParse.split('-busqueda-'),
      _urlToParse$split2 = _slicedToArray(_urlToParse$split, 2),
      params = _urlToParse$split2[0],
      busqueda = _urlToParse$split2[1];

  if (busqueda) busqueda = (_a = busqueda) === null || _a === void 0 ? void 0 : _a.split('-').join(' ');
  var tipoTrabajoArray = Object.keys(facets_1.filterMap.tipo_trabajo);
  var tipoTrabajoTrad = tipoTrabajoArray.map(function (e) {
    return i18n_1.default.t("url.tipo-trabajo.".concat(e));
  });
  var tipoTrabajo;
  tipoTrabajoTrad.some(function (element) {
    if (element === 'primer-empleo' && params.includes('seniority-primer-empleo') && !params.match(/primer-empleo(.*)seniority-primer-empleo/)) {
      return false;
    }

    var elementRe = new RegExp("-".concat(element, "(.*)"));
    var matchElement = params.match(elementRe);

    if (matchElement) {
      tipoTrabajo = element;
      params = params.split(elementRe).join('');
      return true;
    }

    return false;
  });
  var salarioRx = /-\$(\d+|\*)-\$(\d+|\*)/;
  var salarioMatch = salarioRx.exec(params);

  if (salarioMatch) {
    filtros.salario = ["".concat(salarioMatch[1], "-").concat(salarioMatch[2])];
    params = params.replace(salarioRx, '');
  }

  var splitParams = params.split('/empleos');

  if (!splitParams[1]) {
    var toReturn = {};
    if (busqueda) toReturn.busqueda = busqueda;
    if (tipoTrabajo) toReturn.tipo_trabajo = i18n_1.default.t("url-vuelta.tipo-trabajo.".concat(tipoTrabajo));
    if (filtros.salario) toReturn.salario = filtros.salario.join('-');
    if (filtros.provincia) toReturn.provincia = filtros.provincia.join('-');
    if (filtros.localidad) toReturn.localidad = filtros.localidad.join('-');
    return toReturn;
  }

  var splitedURL = splitParams[1].split('-');
  var lastKey;
  splitedURL.forEach(function (currentWord) {
    var tCurrentWord = facets_1.tagsTranslationMap.toBFFId[currentWord] ? facets_1.tagsTranslationMap.toBFFId[currentWord] : currentWord;

    if (filtros[tCurrentWord]) {
      lastKey = tCurrentWord;
    } else if (lastKey) {
      filtros[lastKey].push(tCurrentWord);
    }
  });
  if (busqueda) filtros.busqueda = [busqueda];
  if (tipoTrabajo) filtros.tipo_trabajo = [tipoTrabajo];
  var keys = Object.keys(filtros);
  keys.forEach(function (key) {
    if (lodash_1.isEmpty(filtros[key])) {
      delete filtros[key];
    } else {
      var filtroDestraducido;
      var filtroConTraduccion = filtros[key].join('-');

      if (key === 'apto_discapacitado') {
        filtroDestraducido = i18n_1.default.t("url-vuelta.discapacitados.".concat(filtroConTraduccion));
      } else if (key === 'area' || key === 'subarea' || key === 'tipo_trabajo' || key === 'distancia') {
        var keySinGuionBajo = key.replace(/_/g, '-');
        filtroDestraducido = i18n_1.default.t("url-vuelta.".concat(keySinGuionBajo, ".").concat(filtroConTraduccion), filtroConTraduccion);
      } else {
        filtroDestraducido = filtroConTraduccion;
      }

      filtros[key] = filtroDestraducido;
    }
  });
  return filtros;
};

exports.separateLocalidadFromProvincia = function (provincia, localidad) {
  return localidad.replace(new RegExp("-".concat(provincia, "$")), '');
};

var translateFiltros = function translateFiltros(filtros) {
  var translatedFiltros = {};
  var keys = Object.keys(filtros);
  keys.forEach(function (key) {
    var translatedKey = facets_1.tagsTranslationMap.toPath[key];

    if (translatedKey) {
      translatedFiltros[translatedKey] = filtros[key];
    } else {
      translatedFiltros[key] = filtros[key];
    }
  });
  return translatedFiltros;
};

var translateFiltrosTags = function translateFiltrosTags(filtrosTags) {
  var translatedKeys = [];
  filtrosTags.forEach(function (key) {
    translatedKeys.push(facets_1.tagsTranslationMap.toPath[key]);
  });
  return translatedKeys;
};

var orderFiltrosTags = function orderFiltrosTags(filtrosTags) {
  var keysOrder = ['area', 'subarea', 'tipo_trabajo', 'apto_discapacitado', 'dias_fecha_publicacion', 'distancia', 'salario', 'nivel_laboral', 'modalidad_trabajo', 'busqueda'];
  var arr = keysOrder.filter(function (value) {
    return filtrosTags.includes(value);
  });
  return arr;
};

exports.makeURL = function (filtrosParam) {
  var url = '';
  var filtros = Object.assign({}, filtrosParam);

  if (filtros && filtros.busqueda) {
    filtros.busqueda = config_1.formatNameToStringId(filtros.busqueda);
  }

  if (filtros.provincia) {
    url += "/en-".concat(filtros.provincia);
  }

  if (filtros.provincia && filtros.localidad) {
    url += "/".concat(filtros.localidad);
  }

  delete filtros.localidad;
  delete filtros.provincia;

  if (filtros.subarea) {
    delete filtros.area;
  }

  if (filtros.salario) {
    var salario = "$".concat(filtros.salario.replace('-', '-$'));
    if (salario === '$*-$*') salario = i18n_1.default.t('url.salario.salario-sin-especificar');
    filtros.salario = salario;
  }

  var keysSinTraducir = Object.keys(filtros);
  filtros = translateFiltros(filtros);
  var keys = translateFiltrosTags(orderFiltrosTags(keysSinTraducir));
  url += '/empleos';
  keys.forEach(function (key) {
    var tag;
    var filtro;

    if (key === 'salario' || key === 'tipo-trabajo') {
      tag = '';
    } else {
      tag = "-".concat(key);
    }

    if (key === 'tipo-trabajo' || key === 'area' || key === 'subarea' || key === 'discapacitados') {
      filtro = "".concat(i18n_1.default.t("url.".concat(key, ".").concat(filtros[key]), filtros[key]));
    } else if (key === 'distancia') {
      filtro = "".concat(i18n_1.default.t("url.".concat(key, ".").concat(parseInt(filtros[key] || '', 10))));
    } else {
      filtro = filtros[key];
    }

    if (filtro) url += "".concat(tag, "-").concat(filtro);
  });
  url += '.html';
  return url.replace(/_/g, '-');
};

exports.filtroProvincia = function (_ref2) {
  var provincia = _ref2.provincia,
      localidad = _ref2.localidad;
  if (!provincia) return [];

  if (provincia && localidad) {
    return [{
      id: 'provincia',
      value: "".concat(localidad, "-").concat(provincia)
    }];
  }

  return [{
    id: 'provincia',
    value: "".concat(provincia)
  }];
};

exports.formatFilterData = function (filtersApplied) {
  if (!filtersApplied) return {};
  return filtersApplied.reduce(function (acc, filtro) {
    if (filtro.type) {
      acc[filtro.type] = filtro.name;
    } else if (filtro.id) {
      if (filtro.id === 'query') {
        acc.busqueda = filtro.value;
      } else {
        acc[filtro.id] = filtro.value;
      }
    }

    return acc;
  }, {});
};

exports.makeURLV2 = function (filtrosParam) {
  var ubicacion = filters_1.ProvinciaLocalidadFilter.makeFilter(filtrosParam);
  var url = '/empleos';

  if (filtrosParam.subarea) {
    url += filters_1.SubareaFilter.makeFilter(filtrosParam.subarea);
  } else {
    url += filters_1.AreaFilter.makeFilter(filtrosParam.area);
  }

  url += filters_1.TipoTrabajoFilter.makeFilter(filtrosParam.tipo_trabajo);
  url += filters_1.AptoDiscapacitadoFilter.makeFilter(filtrosParam.apto_discapacitado);
  url += filters_1.DiasFechaPublicacionFilter.makeFilter(filtrosParam.dias_fecha_publicacion);
  url += filters_1.NivelLaboralFilter.makeFilter(filtrosParam.nivel_laboral);
  url += filters_1.ModalidadTrabajoFilter.makeFilter(filtrosParam.modalidad_trabajo);
  url += filters_1.BusquedaFilter.makeFilter(filtrosParam.busqueda);
  return ubicacion + url + '.html';
};

exports.parseURLV2 = function (url, match) {
  var split = url.split('/empleos');
  var urlToParse = split[1].split('.html')[0];
  var busqueda = filters_1.BusquedaFilter.parseFilter(urlToParse);
  var modalidadTrabajo = filters_1.ModalidadTrabajoFilter.parseFilter(busqueda.url);
  var nivelLaboral = filters_1.NivelLaboralFilter.parseFilter(modalidadTrabajo.url);
  var diasFechaPublicacion = filters_1.DiasFechaPublicacionFilter.parseFilter(nivelLaboral.url);
  var aptoDiscapacitado = filters_1.AptoDiscapacitadoFilter.parseFilter(diasFechaPublicacion.url);
  var tipoTrabajo = filters_1.TipoTrabajoFilter.parseFilter(aptoDiscapacitado.url);
  var subarea = filters_1.SubareaFilter.parseFilter(tipoTrabajo.url);
  var area = filters_1.AreaFilter.parseFilter(subarea.url);

  var _filters_1$ProvinciaL = filters_1.ProvinciaLocalidadFilter.parseFilter(match),
      localidad = _filters_1$ProvinciaL.localidad,
      provincia = _filters_1$ProvinciaL.provincia;

  var filtros = {
    busqueda: busqueda.result,
    modalidad_trabajo: modalidadTrabajo.result,
    nivel_laboral: nivelLaboral.result,
    dias_fecha_publicacion: diasFechaPublicacion.result,
    apto_discapacitado: aptoDiscapacitado.result,
    tipo_trabajo: tipoTrabajo.result,
    area: area.result,
    subarea: subarea.result,
    localidad: localidad,
    provincia: provincia
  };

  for (var f in filtros) {
    if (filtros[f] === undefined) {
      delete filtros[f];
    }
  }

  return filtros;
};

var tiposFacetas = {
  SUB_AREA: 'subarea'
};

var convertTipoFaceta = function convertTipoFaceta(tipoFaceta) {
  var tipoFacetaConverted = tiposFacetas[tipoFaceta] || tipoFaceta;
  return tipoFacetaConverted.toLowerCase();
};

exports.formatFilterDataV2 = function (filtersApplied) {
  return filtersApplied.reduce(function (acc, filtro) {
    var tipoFacetaConverted = convertTipoFaceta(filtro.type);
    acc[tipoFacetaConverted] = filtro.idSemantico;
    return acc;
  }, {});
};